import React, { useEffect, useState } from 'react'
import './index.css';
import bgimage from '../../assets/svg/bgimg.svg';
import loginImage from '../../assets/svg/loginimg.svg';
import mailimg from '../../assets/svg/mailicon.svg';
import loginIcon from '../../assets/svg/Login.svg';
import route from '../../utils/Routes';
import { Typography, TextField, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import { useAuthContext } from '../../context/AuthContext';
import { customAlert, notify } from '../../components/notify';
import { sendLoginOtpServ } from '../../services/login-service';
import constants from '../../utils/Constants';

function LoginPage() {
  const [formErrors, setFormErrors] = useState({});
  const { setLoadingScreen, ctxtUser } = useAuthContext();
  const navigate = useNavigate();

  const cancelCourse = () => {
    document.getElementById("formId").reset();
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);

    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object

    let errorsObj = validateLogin(inputObject);
    setFormErrors(errorsObj);

    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);

    try {
      const { message } = await sendLoginOtpServ(inputObject);
      notify("success", message);
      navigate(route.otpveryfication, { state: { email: inputObject.email } });
      setLoadingScreen(false);
      cancelCourse();
    } catch (err) {
      console.log(err);
      customAlert(err);

    }
    setLoadingScreen(false);
  };

  function validateLogin(values) {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }

    return errors;
  };


  useEffect(() => {
    setLoadingScreen(true);
    if (ctxtUser?.token) {
      if (ctxtUser?.isComUser)
        navigate(route.comDashboard, { replace: true });
      else if (ctxtUser?.userType === constants.accounts)
        navigate(route.aPolist, { replace: true });
      else
        navigate(route.adminDash, { replace: true });
    }
    else
      navigate(route.login, { replace: true });
    setLoadingScreen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <div className='bg'>
      <img src={bgimage} alt="bgimage" style={{ width: "100vw", position: "absolute" }} />
      <img src={loginImage} alt="logo" style={{ width: "50%", height: "25rem", top: "12rem", position: "absolute" }} />

      <Typography sx={{ fontSize: 30, fontWeight: 700, left: "71vw", marginTop: "19vh", position: "absolute" }}>Welcome!</Typography>

      <form style={{ position: "relative", left: "62vw", marginTop: "26vh", }} id='formId' onSubmit={handleSubmit}>
        <Stack className='logingrid' sx={{ alignItems: "center", width: 405, height: "24rem" }}>
          <Stack sx={{ alignItems: "left" }}>
            <Stack direction={"row"} sx={{ mt: 5, }}>
              <Typography sx={{ fontSize: 26, fontWeight: 600 }}>Login</Typography>
              <img src={loginIcon} alt="bgimage" style={{ width: 28, marginLeft: 15 }} />
            </Stack>
            <Typography sx={{ fontSize: 10, fontWeight: 200 }}>for Seamless Procurement</Typography>
            <Typography sx={{ color: "secondary.main", mt: 6, fontSize: 14, fontWeight: 400 }}>Email ID</Typography>
            <TextField
              type='email' variant="outlined" size="small" name='email'
              error={formErrors.email && true} helperText={formErrors.email && formErrors.email}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start" sx={{ font: 1 }}>
                      <img src={mailimg} alt="mailimg" style={{ height: 17 }} />
                    </InputAdornment>),
                },
              }}
              sx={{ mt: 0.5, backgroundColor: "white", width: 320, Size: 1 }} />
          </Stack>
          <Button sx={{ mt: 3, borderRadius: 2, backgroundColor: "primary.button", width: 200, fontSize: 16, px: 1, py: 0, height: 35 }}
            variant="contained" type='submit' >Continue</Button>
          <Typography sx={{ mt: 7, fontSize: 10, fontWeight: 400 }}>By continuing, you agree to <a href="#/" style={{ color: "black" }}>Condition of use</a> and <a href="#/" style={{ color: "black" }}>Privacy Policy</a>.</Typography>
        </Stack>
      </form>
      <Stack sx={{ width: "100%", alignItems: "center", marginTop: "90vh", position: "relative" }}>
        <Typography sx={{ fontSize: 14, fontWeight: 400 }}> © 2024, Al Muhra Al Aseela Trading & Contracting.</Typography>
      </Stack>
    </div>
  )
}

export default LoginPage;